// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3016":"0b807f8d","3671":"a83f4675","3912":"a83f4675","4522":"0b807f8d","5680":"0b807f8d","6572":"a83f4675","7399":"95572145","9053":"0b807f8d"}[chunkId] + ".chunk.css";
};